/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.OrderCompanyResponseDto>
>;
export function request(
  params: API.basics.orderCompany.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/orderCompany/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
